import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
let QuizQuestionLabel = class QuizQuestionLabel extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "label", void 0);
    _defineProperty(this, "labelDetail", void 0);
  }
};
__decorate([Prop({
  default: ''
})], QuizQuestionLabel.prototype, "label", void 0);
__decorate([Prop({
  default: ''
})], QuizQuestionLabel.prototype, "labelDetail", void 0);
QuizQuestionLabel = __decorate([Component], QuizQuestionLabel);
export default QuizQuestionLabel;